var N = Object.defineProperty;
var x = (c, o, t) => o in c ? N(c, o, { enumerable: !0, configurable: !0, writable: !0, value: t }) : c[o] = t;
var s = (c, o, t) => x(c, typeof o != "symbol" ? o + "" : o, t);
import { BaseClient as i, RequestError as b, BaseRootClient as f } from "@mottmac-moata/base-api-client";
import { RequestError as jt } from "@mottmac-moata/base-api-client";
import { z as n } from "zod";
const h = "/api/OAuth2", M = `${h}/GetToken`, D = `${h}/RefreshToken`, J = `${h}/InvalidateToken/:userId`, w = `${h}/GetProjectScopedToken`, B = `${h}/ProjectScopedRefreshToken`, v = n.object({
  code: n.string({ message: "Expected code to not be empty" }).min(1, { message: "Expected code to not be empty" }),
  policy: n.string({ message: "Expected policy to not be empty" }).min(1, { message: "Expected policy to not be empty" })
}), q = n.object({
  refresh_token: n.string({ message: "Expected refresh_token to not be empty" }).min(1, { message: "Expected refresh_token to not be empty" }),
  policy: n.string({ message: "Expected policy to not be empty" }).min(1, { message: "Expected policy to not be empty" })
}), L = n.object({
  userId: n.string({ message: "Expected userId to be a non-empty string" }).min(1, { message: "Expected userId to be a non-empty string" })
}), F = n.object({
  projectId: n.number({ message: "Expected projectId to be a number" }),
  setCookie: n.boolean({ message: "Expected setCookie to be a boolean" }).optional()
}), K = n.object({
  refresh_token: n.string({ message: "Expected refresh_token to be a non-empty string" }).min(1, { message: "Expected refresh_token to be a non-empty string" }),
  setCookie: n.boolean({ message: "Expected setCookie to be a boolean" }).optional()
});
class V extends i {
  constructor() {
    super(...arguments);
    s(this, "getToken", async (t, e) => (v.parse(t), await this.requestTokens(
      {
        pathTemplate: M,
        data: t
      },
      e
    )));
    s(this, "refreshToken", async (t, e) => (q.parse(t), await this.requestTokens(
      {
        pathTemplate: D,
        data: t
      },
      e
    )));
    s(this, "invalidateToken", async (t, e) => (L.parse(t), this.post({ pathTemplate: J, params: t }, e)));
    s(this, "getTokenProjectScoped", async (t, e) => (F.parse(t), await this.post(
      {
        pathTemplate: w,
        query: t
      },
      e
    )));
    s(this, "refreshTokenProjectScoped", async (t, e) => (K.parse(t), await this.post(
      {
        pathTemplate: B,
        query: { setCookie: t.setCookie },
        data: { refresh_token: t.refresh_token }
      },
      e
    )));
  }
  async requestTokens({ pathTemplate: t, data: e }, a) {
    return await this.post({ pathTemplate: t, data: e }, a);
  }
}
const Y = n.object({
  metadataAddress: n.string({ message: "Metadata address cannot be empty" })
});
class z extends i {
  constructor(t) {
    super({ ...t, baseUrl: "" });
    s(this, "getMetadata", async (t, e) => {
      Y.parse(t);
      const a = await this.request(t.metadataAddress, { method: "GET", ...e });
      if (!a.ok) {
        const G = await a.text();
        throw new b("Request Failed", {
          text: G,
          status: a.status,
          statusText: a.statusText
        });
      }
      return await a.json();
    });
  }
}
const P = "/api/Product", A = `${P}/:productId`, W = "/api/ProductManagement", E = `${W}/:productId`;
class Q extends i {
  constructor() {
    super(...arguments);
    s(this, "getProducts", async (t, e) => this.get({ pathTemplate: P, query: t }, e));
    s(this, "getById", async (t, e) => this.get({ pathTemplate: A, params: { productId: t } }, e));
    s(this, "create", async (t, e) => this.post({ pathTemplate: P, data: t }, e));
  }
}
const l = `${E}/actions`, u = `${l}/:actionId`, X = `${u}/groups`, U = `${X}/:groupId`;
class Z extends i {
  constructor() {
    super(...arguments);
    s(this, "getAll", async (t, e) => this.get({ pathTemplate: l, params: { productId: t } }, e));
    s(this, "create", async (t, e) => this.post(
      { pathTemplate: l, params: { productId: t.productId }, data: t.data },
      e
    ));
    s(this, "update", async (t, e) => this.put(
      {
        pathTemplate: u,
        params: { productId: t.productId, actionId: t.actionId },
        data: t.data
      },
      e
    ));
    s(this, "deleteOne", async (t, e, a) => this.delete({ pathTemplate: u, params: { productId: t, actionId: e } }, a));
    s(this, "addToGroup", async (t, e) => this.post({ pathTemplate: U, params: t }, e));
    s(this, "removeFromGroup", async (t, e) => this.delete({ pathTemplate: U, params: t }, e));
  }
}
const _ = `${E}/groups`, d = `${_}/:groupId`, T = `${d}/users`;
class tt extends i {
  constructor() {
    super(...arguments);
    s(this, "create", async (t, e, a) => this.post({ pathTemplate: _, params: { productId: t }, data: e }, a));
    s(this, "update", async (t, e, a) => this.put({
      pathTemplate: d,
      params: { productId: t, groupId: e },
      data: a
    }));
    s(this, "deleteOne", async (t, e, a) => this.delete({ pathTemplate: d, params: { productId: t, groupId: e } }, a));
    s(this, "getById", async (t, e, a) => this.get({ pathTemplate: d, params: { productId: t, groupId: e } }, a));
    s(this, "getAll", async (t, e) => this.get({ pathTemplate: _, params: { productId: t } }, e));
    s(this, "getUsers", (t, e, a) => this.get(
      { pathTemplate: T, params: { productId: t, groupId: e } },
      a
    ));
    s(this, "removeUsers", (t, e, a, p) => this.delete(
      { pathTemplate: T, params: { productId: t, groupId: e }, data: a },
      p
    ));
    s(this, "addUsers", (t, e, a, p) => this.post({ pathTemplate: T, params: { productId: t, groupId: e }, data: a }, p));
    s(this, "setUsers", (t, e, a, p) => this.put({ pathTemplate: T, params: { productId: t, groupId: e }, data: a }, p));
  }
}
const et = `${E}/users`;
class st extends i {
  constructor() {
    super(...arguments);
    s(this, "getAllByProductId", (t, e) => this.get({ pathTemplate: et, params: { productId: t } }, e));
  }
}
const j = "/api/Project", r = `${j}/:projectId`, at = `${r}/actions/me`, ot = `${r}/termsandconditions`, nt = `${r}/invite`, ct = `${r}/invite-template`;
class pt extends i {
  constructor() {
    super(...arguments);
    s(this, "getById", async ({ projectId: t }, e) => this.get({ pathTemplate: r, params: { projectId: t } }, e));
    s(this, "create", async (t, e) => this.post({ pathTemplate: j, data: t }, e));
    s(this, "update", async (t, e, a) => this.put({ pathTemplate: r, params: { projectId: t }, data: e }, a));
    s(this, "acceptTermsAndConditions", async ({ projectId: t }, e) => this.post({ pathTemplate: ot, params: { projectId: t } }, e));
    s(this, "getEmailInviteTemplate", async ({ projectId: t }, e) => this.get({ pathTemplate: ct, params: { projectId: t } }, e));
  }
}
const C = `${r}/groups`, y = `${r}/group`, rt = `${y}/:groupId/users`, g = `${y}/:groupId`, it = `${g}/actions`;
class ht extends i {
  constructor() {
    super(...arguments);
    s(this, "create", async (t, e, a) => this.post({ pathTemplate: y, params: { projectId: t }, data: e }, a));
    s(this, "update", async (t, e, a) => this.put({
      pathTemplate: g,
      params: { projectId: t, groupId: e },
      data: a
    }));
    s(this, "deleteMany", async (t, e, a) => this.delete({ pathTemplate: C, params: { projectId: t }, data: e }, a));
    s(this, "getById", async (t, e, a) => this.get({ pathTemplate: g, params: { projectId: t, groupId: e } }, a));
    s(this, "getAllByProjectId", async (t, e) => this.get({ pathTemplate: C, params: { projectId: t } }, e));
    s(this, "setUsers", async (t, e, a) => this.put({ pathTemplate: rt, params: { projectId: t, groupId: e }, data: a }));
    s(this, "putActions", async (t, e, a, p) => this.put(
      { pathTemplate: it, params: { projectId: t, groupId: e }, data: a },
      p
    ));
  }
}
const S = `${r}/users`, O = `${r}/user/:userId`, H = `${r}/user/:userId/groups`, Tt = `${O}/grantadmin`, dt = `${O}/revokeadmin`, mt = `${r}/groups/:groupId/users`;
class Pt extends i {
  constructor() {
    super(...arguments);
    s(this, "getById", async (t, e, a) => this.get({ pathTemplate: O, params: { projectId: t, userId: e } }, a));
    s(this, "getAllByProjectId", (t, e) => this.get({ pathTemplate: S, params: { projectId: t } }, e));
    s(this, "setGroups", async (t, e, a, p) => this.put({ pathTemplate: H, params: { projectId: t, userId: e }, data: a }, p));
    s(this, "getAllByGroupId", async (t, e, a) => this.get(
      {
        pathTemplate: mt,
        params: { projectId: t, groupId: e }
      },
      a
    ));
    s(this, "removeFromGroup", async (t, e, a, p) => this.delete(
      { pathTemplate: H, params: { projectId: t, userId: e }, data: a },
      p
    ));
    s(this, "grantAdmin", async (t, e, a) => this.put({ pathTemplate: Tt, params: { projectId: t, userId: e } }, a));
    s(this, "revokeAdmin", async (t, e, a) => this.put({ pathTemplate: dt, params: { projectId: t, userId: e } }, a));
    s(this, "invite", async (t, e) => this.post({ pathTemplate: nt, params: { projectId: t }, data: e }));
    s(this, "deleteMany", async (t, e) => this.delete({ pathTemplate: S, params: { projectId: t }, data: e }));
  }
}
const lt = `${A}/actions`, $ = `${A}/action`, k = `${$}/:actionId`;
class ut extends i {
  constructor() {
    super(...arguments);
    s(this, "getAll", async (t, e) => this.get({ pathTemplate: lt, params: { productId: t } }, e));
    s(this, "create", async (t, e) => this.post(
      { pathTemplate: $, params: { productId: t.productId }, data: t.data },
      e
    ));
    s(this, "update", async (t, e) => this.put(
      {
        pathTemplate: k,
        params: { productId: t.productId, actionId: t.actionId },
        data: t.data
      },
      e
    ));
    s(this, "deleteOne", async (t, e, a) => this.delete({ pathTemplate: k, params: { productId: t, actionId: e } }, a));
  }
}
const R = "/api/User", _t = `${R}/getUserId`, gt = `${R}/loginpolicy`, m = `${R}/me`, At = `${m}/products/access`, I = `${m}/projects`, Et = `${I}/:projectName`, yt = `${I}/:projectId`, Ot = n.object({
  email: n.string({ message: "Expected email to not be empty" })
});
class Rt extends i {
  constructor() {
    super(...arguments);
    s(this, "me", (t) => this.get({ pathTemplate: m }, t));
    s(this, "actions", ({ projectId: t }, e) => this.get({ pathTemplate: at, params: { projectId: t } }, e));
    s(this, "updateMe", async (t, e) => this.patch(
      {
        pathTemplate: m,
        data: t
      },
      e
    ));
    s(this, "getUserId", async ({ email: t }, e) => this.get({ pathTemplate: _t, query: { email: t } }, e));
    s(this, "getLoginPolicy", async (t, e) => (Ot.parse(t), this.get({ pathTemplate: gt, query: t }, e)));
    s(this, "getProductsWithAccess", (t) => this.get({ pathTemplate: At }, t));
    s(this, "getProjects", (t, e) => this.get({ pathTemplate: I, query: t }, e));
    s(this, "getProjectByName", ({ projectName: t }, e) => this.get({ pathTemplate: Et, params: { projectName: t } }, e));
    s(this, "getProjectById", ({ projectId: t }, e) => this.get({ pathTemplate: yt, params: { projectId: t } }, e));
  }
}
class St extends f {
  constructor(t) {
    super(t);
    s(this, "OAuth2");
    s(this, "Policy");
    s(this, "Product");
    s(this, "ProductAction");
    s(this, "ProductGroup");
    s(this, "ProductUser");
    s(this, "Project");
    s(this, "ProjectGroup");
    s(this, "ProjectUser");
    s(this, "ProjectAction");
    s(this, "User");
    this.OAuth2 = new V(this.configs), this.clients.push(this.OAuth2), this.Policy = new z(this.configs), this.clients.push(this.Policy), this.Product = new Q(this.configs), this.clients.push(this.Product), this.ProductAction = new Z(this.configs), this.clients.push(this.ProductAction), this.ProductGroup = new tt(this.configs), this.clients.push(this.ProductGroup), this.ProductUser = new st(this.configs), this.clients.push(this.ProductUser), this.Project = new pt(this.configs), this.clients.push(this.Project), this.ProjectGroup = new ht(this.configs), this.clients.push(this.ProjectGroup), this.ProjectUser = new Pt(this.configs), this.clients.push(this.ProjectUser), this.ProjectAction = new ut(this.configs), this.clients.push(this.ProjectAction), this.User = new Rt(this.configs), this.clients.push(this.User);
  }
}
export {
  St as MoataIdentityAPI,
  V as OAuth2,
  z as Policy,
  Q as Product,
  Z as ProductAction,
  tt as ProductGroup,
  st as ProductUser,
  pt as Project,
  ut as ProjectAction,
  ht as ProjectGroup,
  Pt as ProjectUser,
  jt as RequestError,
  Rt as User
};
//# sourceMappingURL=identity-sdk.js.map
